import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useTranslation } from '@ibk/shared-translation';
import { getFinanceiroTabs } from './financeiro.config';
import styles from './FinanceiroLayout.module.css';
export function FinanceiroLayout({ showAccountsPayable = true }) {
    const { t } = useTranslation();
    const tabs = getFinanceiroTabs(t, showAccountsPayable);
    return (_jsxs("div", { className: styles.wrapper, children: [_jsx("nav", { className: styles.navigation, "aria-label": t('financeiro.navigation-label'), children: tabs.map(item => (_jsx(NavLink, { to: item.route, end: item.route !== '/financeiro/contas-a-receber', className: ({ isActive }) => (isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab), children: item.title }, item.route))) }), _jsx("div", { className: styles.content, children: _jsx(Outlet, {}) })] }));
}
export default FinanceiroLayout;
